import { FC, useEffect, useState } from 'react';
import { trpc } from 'src/trpc';
import { useUser } from './context/UserContext';
import { SentryMonitoringService } from '@libs/frontend-services';
declare global {
  interface Window {
    __FEATURE_FLAGS__: { name: string; enabled: boolean }[];
  }
}

export const GuaranteeFeatures: FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useUser();
  const [featureFlagsSet, setFeatureFlagsSet] = useState<boolean>(false);
  const sentryMonitoringService = new SentryMonitoringService();
  const {
    data: featureFlags,
    isLoading,
    error,
  } = trpc.admin.featureFlags.listFeatureFlags.useQuery(undefined, {
    enabled: !!user,
  });
  useEffect(() => {
    if (featureFlags?.featureFlags) {
      window.__FEATURE_FLAGS__ = featureFlags?.featureFlags || [];
      setFeatureFlagsSet(true);
    }
    if (error) {
      sentryMonitoringService.captureMessage('Error fetching feature flags', 'error', { error });
      window.__FEATURE_FLAGS__ = [];
    }
  }, [featureFlags?.featureFlags, error]);
  if (isLoading && user) {
    return null;
  }
  if (!user || featureFlagsSet) {
    return children;
  }
  return null;
};
